import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import AchievementsQuery from './AchievementsQuery';

const AchievementsConnectorApollo = ({ children }) => {
  const { loading, data, error } = useQuery(AchievementsQuery);
  const result = {
    loading,
    error,
  };

  if (error) {
    throw error;
  }

  if (!loading) {
    result.achievements = data.me.achievements;
  }
  return children(result);
};

AchievementsConnectorApollo.propTypes = {
  children: PropTypes.func.isRequired,
};

export default AchievementsConnectorApollo;
